export default [
    {
        path: '/returns',
        meta: { label: 'Returns' },
        component: {
            render(c) { return c('router-view') }
        },
        children: [
            {
                path: '',
                name: 'returns',
                meta: {
                    label: 'Returns',
                    permission: 'show_all_returns'
                },
                component: () => import('./../../views/returns/index.vue'),
            },
            {
                path: "create",
                name: "create_return",
                component: () => import("../../views/returns/create.vue"),
                meta: {
                    permission: "create_returns",
                },
            },
            {
                path: "approvals",
                name: "return_approvals",
                component: () => import("../../views/returns/approvals.vue"),
                meta: {
                    permission: "create_approve_return",
                    label: "Return Approvals"
                },
            },
            {
                path: ":orderId",
                name: "show_return",
                component: () => import("../../views/returns/show.vue"),
                meta: {
                    permission: "show_single_returns",
                },
            },
        ]
    },
];
